import { User, Check, X } from "lucide-react";
import React from "react";

interface CustomerNameProps {
  visible: boolean;
  name: string;
  onConfirm: (confirm: boolean) => void;
}

const CustomerName = (props: CustomerNameProps) => {
  return props.visible ? (
    <div className="space-y-4 mb-8">
      {/* Step heading with icon */}
      <div className="flex items-center gap-2">
        <User className="h-6 w-6 text-primary" />
        <h3 className="text-xl font-bold text-foreground">Paso 2.</h3>
      </div>

      {/* Instruction text */}
      <p className="text-muted-foreground">Confirma que tu nombre es:</p>

      {/* Name display with confirm buttons */}
      <div className="flex gap-3">
        <div className="flex-1 flex items-center justify-center bg-white border border-input rounded-lg px-4 py-3">
          <span className="text-lg font-medium text-foreground underline">
            {props.name}
          </span>
        </div>
        <button
          onClick={() => props.onConfirm(true)}
          className="bg-primary hover:bg-primary/90 text-primary-foreground rounded-lg px-6 py-3 transition-colors shadow-medium"
        >
          <Check className="h-5 w-5" />
        </button>
        <button
          onClick={() => props.onConfirm(false)}
          className="bg-destructive hover:bg-destructive/90 text-destructive-foreground rounded-lg px-6 py-3 transition-colors shadow-medium"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
    </div>
  ) : (
    <div></div>
  );
};

export default CustomerName;
